import { Component } from '@angular/core';
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-info-terapia-fisica',
  standalone: true,
  imports: [
    NgOptimizedImage
  ],
  templateUrl: './info-terapia-fisica.component.html',
  styleUrl: './info-terapia-fisica.component.css'
})
export class InfoTerapiaFisicaComponent {

}
